import React from "react";
import PropTypes from 'prop-types';
import {Grid, Paper, Typography} from "@material-ui/core";
import CurrencyField from "../Fields/CurrencyField";
import TextField from "../Fields/TextField";
import useStyles from "../../styles/styles";

const LeadPurchasePriceRejectOfferInformation = ({offer}) => {
    const classes = useStyles();

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"lead-purchase-price-reject-offer"}>Lead Purchase Price Reject Offer</Typography>
            {offer ? (
                <Paper className={classes.paper}>
                    <Grid container spacing={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}>
                                <TextField label="Status" value={offer.status || ''}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Original RequestId" value={offer.originalRequestId}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Expiration" value={offer.expiration}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Identity Id" value={offer.identityId}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Primary Email" value={offer.primaryEmail}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CurrencyField label="Offer Amount" value={offer.offerAmount}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Redeemed Request Id" value={offer.redeemedRequestId}/>
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <TextField label="Redeemed Timestamp" value={offer.redeemedTimestamp}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            ) : null}
        </>
    )
};

LeadPurchasePriceRejectOfferInformation.propTypes = {
    offer: PropTypes.shape({
        originalRequestId: PropTypes.string,
        status: PropTypes.string,
        expiration: PropTypes.string,
        identityId: PropTypes.string,
        primaryEmail: PropTypes.string,
        offerAmount: PropTypes.number,
        redeemedRequestId: PropTypes.string,
        redeemedTimestamp: PropTypes.string
    }),
};

LeadPurchasePriceRejectOfferInformation.defaultProps = {
    offer: {},
};

export default LeadPurchasePriceRejectOfferInformation;
